// src/api/authService.ts
import api from "./Client";

export type ResetPasswordState =
  | { status: "idle" }
  | { status: "loading" }
  | { status: "success"; message: string }
  | { status: "error"; message: string };

export async function resetPassword(email: string): Promise<ResetPasswordState> {
  try {
    const res = await api.put("/api/mobile/reset-password", { email });
    const data = res.data as { message?: string; error?: string };

    if (res.status === 200) {
      return { status: "success", message: data.message || "Contraseña restablecida. Revisa tu correo." };
    }
    return { status: "error", message: data?.error || "Error al restablecer la contraseña" };
  } catch (err: any) {
    return {
      status: "error",
      message: err.response?.data?.error || "Error de conexión. Inténtalo de nuevo",
    };
  }
}
